// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-import-item {
  width: 100%;
  position: relative;
  padding: 5px 0;
}
.tree-import-item .tree-import-col {
  width: 100%;
}
.tree-import-item .tree-import-section {
  background-color: #f5f8fa;
  border-left: 4px solid #3680bf;
  display: flex;
  width: 100%;
  font-weight: 700;
  font-size: 14px;
  text-transform: initial;
  padding: 10px 0;
}
.tree-import-item .tree-import-content {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 10px;
}
.tree-import-item .tree-import-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
}
.tree-import-item .tree-import-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.tree-import-item .tree-import-name {
  flex: 1 1;
  font-size: 12px;
}
.tree-import-item .tree-import-expand-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: auto;
}
.tree-import-item .tree-import-expand-btn:hover {
  opacity: 0.7;
}
.tree-import-item .tree-import-child {
  padding-left: 20px;
}

.categoryBackGroup {
  background-color: #f5f8fa;
}

.subCategoryBackGroup {
  background-color: #ccd7df;
}

.tree-container {
  padding: 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Cadastro/Produtos/FormProduto/ModalPizza/FooterIntern/ModalFamily/treeImportStyles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;AACJ;AAEE;EACE,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAFJ;AAII;EACE,mBAAA;EACA,YAAA;AAFN;AAME;EACE,SAAA;EACA,eAAA;AAJJ;AAOE;EACE,6BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;AALJ;AAOI;EACE,YAAA;AALN;AASE;EACE,kBAAA;AAPJ;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,eAAA;AARF","sourcesContent":[".tree-import-item {\n  width: 100%;\n  position: relative;\n  padding: 5px 0;\n\n  .tree-import-col {\n    width: 100%;\n  }\n\n  .tree-import-section {\n    background-color: #f5f8fa;\n    border-left: 4px solid #3680bf;\n    display: flex;\n    width: 100%;\n    font-weight: 700;\n    font-size: 14px;\n    text-transform: initial;\n    padding: 10px 0;\n  }\n\n  .tree-import-content {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 0 10px;\n  }\n\n  .tree-import-checkbox {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    flex-shrink: 0;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n  }\n\n  .tree-import-name {\n    flex: 1;\n    font-size: 12px;\n  }\n\n  .tree-import-expand-btn {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin-left: auto;\n    \n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  .tree-import-child {\n    padding-left: 20px;\n  }\n}\n\n.categoryBackGroup {\n  background-color: #f5f8fa;\n}\n\n.subCategoryBackGroup {\n  background-color: #ccd7df;\n}\n\n.tree-container {\n  padding: 0 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
